import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { CommunityMessage } from '../../services/communityService';

interface ReplyPreviewBarProps {
  replyTo: CommunityMessage;
  onClear: () => void;
}

function previewText(msg: CommunityMessage): string {
  if (msg.message_type === 'deleted' || msg.deleted) return 'Message deleted';
  if (msg.content?.trim()) return msg.content.trim();
  if (msg.forwarded_from?.content_snippet) return msg.forwarded_from.content_snippet;
  switch (msg.message_type) {
    case 'image': return '📷 Photo';
    case 'video': return '🎥 Video';
    case 'audio': return '🎙️ Audio';
    case 'document': return '📎 Document';
    case 'location': return '📍 Location';
    default: return 'Message';
  }
}

export const ReplyPreviewBar: React.FC<ReplyPreviewBarProps> = ({ replyTo, onClear }) => (
  <Box
    sx={{
      px: 2,
      py: 1,
      bgcolor: '#f1f3f4',
      borderTop: '1px solid #e8eaed',
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    }}
  >
    <Box sx={{ borderLeft: '3px solid #0f9d58', pl: 1, flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#0f9d58' }}>
        {replyTo.sender_name_cached}
      </Typography>
      <Typography
        sx={{
          fontSize: '0.8rem',
          color: '#5f6368',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {previewText(replyTo)}
      </Typography>
    </Box>
    <IconButton size="small" onClick={onClear} aria-label="Cancel reply">
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>
);
